var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLargeZip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C8.625 0 7.5 1.125 7.5 2.5V37.5C7.5 38.875 8.625 40 10 40H35C36.375 40 37.5 38.875 37.5 37.5V10L27.5 0H10Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 10H37.5L27.5 0V7.5C27.5 8.875 28.625 10 30 10Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 17.5L30 10H37.5V17.5Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 32.5C32.5 33.1875 31.9375 33.75 31.25 33.75H3.75C3.0625 33.75 2.5 33.1875 2.5 32.5V20C2.5 19.3125 3.0625 18.75 3.75 18.75H31.25C31.9375 18.75 32.5 19.3125 32.5 20V32.5Z",
    fill: "#576D7E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3655 30.0006C9.7355 30.0006 9.4855 29.3918 9.8455 28.9618L13.4042 24.2343H10.4542C9.5855 24.2343 9.6555 23.0068 10.4542 23.0068H14.483C15.2417 23.0068 15.4617 23.7243 14.923 24.3056L11.5142 28.7318H14.763C15.563 28.7318 15.663 30.0018 14.6842 30.0018H10.3655V30.0006Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5703 23.6839C16.5703 22.8639 17.8903 22.8339 17.8903 23.6839V29.3902C17.8903 30.2189 16.5703 30.2402 16.5703 29.3902V23.6839Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6641 23.6841C19.6641 23.3541 19.9241 22.9941 20.3441 22.9941H22.6528C23.9528 22.9941 25.1228 23.8641 25.1228 25.5316C25.1228 27.1116 23.9528 27.9916 22.6528 27.9916H20.9841V29.3116C20.9841 29.7516 20.7041 30.0004 20.3441 30.0004C20.0141 30.0004 19.6641 29.7516 19.6641 29.3116V23.6841ZM20.9828 24.2529V26.7429H22.6516C23.3216 26.7429 23.8516 26.1516 23.8516 25.5316C23.8516 24.8329 23.3216 24.2529 22.6516 24.2529H20.9828Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 33.75H7.5V35H31.25C31.9375 35 32.5 34.4375 32.5 33.75V32.5C32.5 33.1875 31.9375 33.75 31.25 33.75Z",
    fill: "#CAD1D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargeZip);
export default __webpack_public_path__ + "static/media/large_zip.54c2b7d2186b50be0106c710c4ee264d.svg";
export { ForwardRef as ReactComponent };